import { Model } from '../Model.js';

var _dec, _class;
let PrintingFormat = /*#__PURE__*/function (PrintingFormat) {
  PrintingFormat["A4"] = "A4";
  PrintingFormat["A6"] = "A6";
  PrintingFormat["COMBINED_A4"] = "COMBINED_A4";
  PrintingFormat["ORIGINAL"] = "original";
  return PrintingFormat;
}({});
let StaticDisposition = /*#__PURE__*/function (StaticDisposition) {
  StaticDisposition["INLINE"] = "inline";
  StaticDisposition["ATTACHMENT"] = "force-download";
  return StaticDisposition;
}({});

/**
 * Plain object Label representation.
 *
 */

/**
 * Serialized object Label representation.
 *
 */

/**
 * Plain object Packlink's API response representation.
 *
 */

let Label = (_dec = Model(), _dec(_class = class Label {
  /**
   * Takes a ILabelApiResponse from Packlink's API and returns a Label.
   *
   * @param response  ILabelApiResponse response from Packlink's API.
   *
   */
  static createFromResponse(response) {
    const parsedResponse = response.formats.reduce((labelFormats, labelFormat) => ({
      ...labelFormats,
      [labelFormat.format.size]: {
        ...labelFormats[labelFormat.format.size],
        [labelFormat.format.disposition || 'url']: labelFormat.url,
        url: labelFormat.url
      }
    }), {});
    return new Label(parsedResponse[PrintingFormat.A4], parsedResponse[PrintingFormat.A6], parsedResponse[PrintingFormat.COMBINED_A4], parsedResponse[PrintingFormat.ORIGINAL]);
  }

  /**
   * Takes a serialized Label and returns a Label.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Label.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedLabel.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Label.
   *
   */

  /**
   * Takes a serialized Label and returns a Label.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Label.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedLabel.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Label.
   *
   */

  /**
   * Takes a serialized Label and returns a Label.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Label.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedLabel.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Label.
   *
   */

  /**
   * Takes a serialized Label and returns a Label.
   *
   * It allows you to hint the type of data via type params.
   *
   * @typeparam U  Type of the deserialized Label.
   * This allows apps using the SDK to provide their own serialization and deserialization types.
   * By default equals to SerializedLabel.
   * @typeparam P  Type of the serialized data. By default equals to `U`.
   *
   * @param data  Serialized representation of Label.
   *
   */
  static deserialize(data) {
    if (!data) {
      return;
    }
    return new Label(data.A4, data.A6, data.COMBINED_A4, data.ORIGINAL);
  }

  /**
   * Returns a new Label. Typings of the properties depend on the class type param T
   *
   */
  constructor(A4, A6, COMBINED_A4, ORIGINAL) {
    this.A4 = A4;
    this.A6 = A6;
    this.COMBINED_A4 = COMBINED_A4;
    this.ORIGINAL = ORIGINAL;
  }

  /**
   * Returns a JSON serialized version of the Label.
   *
   */
  toJSON() {
    return {
      A4: this.A4,
      A6: this.A6,
      COMBINED_A4: this.COMBINED_A4,
      ORIGINAL: this.ORIGINAL
    };
  }

  /**
   * Returns a clone of the Label.
   *
   */
  clone() {
    return new Label(this.A4 && {
      ...this.A4
    }, this.A6 && {
      ...this.A6
    }, this.COMBINED_A4 && {
      ...this.COMBINED_A4
    }, {
      ...this.ORIGINAL
    });
  }

  /**
   * Returns whether the two Label are equal.
   *
   */
  equals(label) {
    var _label$A, _label$A2, _label$COMBINED_A, _label$ORIGINAL;
    if (!label) {
      return false;
    }
    return this.A4 && this.A4.url === ((_label$A = label.A4) === null || _label$A === void 0 ? void 0 : _label$A.url) && this.A6 && this.A6.url === ((_label$A2 = label.A6) === null || _label$A2 === void 0 ? void 0 : _label$A2.url) && this.COMBINED_A4 && this.COMBINED_A4.url === ((_label$COMBINED_A = label.COMBINED_A4) === null || _label$COMBINED_A === void 0 ? void 0 : _label$COMBINED_A.url) && this.ORIGINAL && this.ORIGINAL.url === ((_label$ORIGINAL = label.ORIGINAL) === null || _label$ORIGINAL === void 0 ? void 0 : _label$ORIGINAL.url) || false;
  }
}) || _class);

export { Label, PrintingFormat, StaticDisposition };
//# sourceMappingURL=Label.js.map
